<div class="bn-case-list flex flex-col gap-3">
  <div
    class="bn-case-list__toolbar flex items-center justify-between gap-3 flex-wrap"
  >
    <div class="bn-case-list__toggles inline-flex items-center" role="tablist">
      <button
        type="button"
        class="bn-case-list__toggle"
        [class.bn-case-list__toggle--active]="activeView() === 'cases'"
        role="tab"
        id="bn-care-plan-cases-tab"
        aria-controls="bn-care-plan-cases-panel"
        [attr.aria-selected]="activeView() === 'cases'"
        [attr.tabindex]="activeView() === 'cases' ? 0 : -1"
        (click)="selectView('cases')"
        (keydown)="onViewTabKeydown($event, 'cases')"
      >
        Cases {{ store.visibleCases().length }}
      </button>
      <button
        type="button"
        class="bn-case-list__toggle"
        [class.bn-case-list__toggle--active]="activeView() === 'actions'"
        role="tab"
        id="bn-care-plan-open-actions-tab"
        aria-controls="bn-care-plan-open-actions-panel"
        [attr.aria-selected]="activeView() === 'actions'"
        [attr.tabindex]="activeView() === 'actions' ? 0 : -1"
        (click)="selectView('actions')"
        (keydown)="onViewTabKeydown($event, 'actions')"
      >
        Open actions {{ actionsStore.count() }}
      </button>
      <button
        type="button"
        class="bn-case-list__toggle"
        [class.bn-case-list__toggle--active]="activeView() === 'outcomes'"
        role="tab"
        id="bn-care-plan-unlinked-outcomes-tab"
        aria-controls="bn-care-plan-unlinked-outcomes-panel"
        [attr.aria-selected]="activeView() === 'outcomes'"
        [attr.tabindex]="activeView() === 'outcomes' ? 0 : -1"
        (click)="selectView('outcomes')"
        (keydown)="onViewTabKeydown($event, 'outcomes')"
      >
        Unlinked Outcomes
        @if (!outcomesStore.loading() && !outcomesStore.error()) {
          {{ outcomesStore.outcomes().length }}
        }
      </button>
    </div>
  </div>

  @if (activeView() === 'cases') {
    <div
      id="bn-care-plan-cases-panel"
      role="tabpanel"
      aria-labelledby="bn-care-plan-cases-tab"
      class="bn-case-list__cases flex flex-col gap-3"
    >
      <div class="bn-case-list__filters" aria-label="Filter cases">
        <span class="bn-case-list__group-by">
          <span class="bn-case-list__group-by-label">Group by</span>
          <p-select
            [fluid]="true"
            [options]="groupByOptions()"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            [ngModel]="store.groupBy()"
            (ngModelChange)="onGroupByChange($event)"
            aria-label="Group cases by"
          />
        </span>
        <p-select
          class="bn-case-list__filter"
          [fluid]="true"
          [options]="statusOptions()"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          [ngModel]="store.filters().status ?? ''"
          (ngModelChange)="onStatusFilterChange($event)"
          aria-label="Filter cases by status"
        />
        <p-select
          class="bn-case-list__filter"
          [fluid]="true"
          [options]="domainOptions()"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          [ngModel]="store.filters().domain ?? ''"
          (ngModelChange)="onDomainFilterChange($event)"
          aria-label="Filter cases by domain"
        />
        @if (
          store.goalsEnabled() &&
          (!store.isLive() || (store.goalsLoaded() && !store.goalsError()))
        ) {
          <p-select
            class="bn-case-list__filter"
            [fluid]="true"
            [options]="goalOptions()"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            [ngModel]="store.filters().goalId ?? ''"
            (ngModelChange)="onGoalFilterChange($event)"
            aria-label="Filter cases by client goal"
          />
        }
      </div>

      @if (!isDefaultFilters()) {
        <div class="bn-case-list__chips flex items-center gap-2 flex-wrap">
          @for (chip of chips(); track chip.dimension) {
            <p-chip
              [label]="chip.label"
              [removable]="true"
              (onRemove)="clearChip(chip.dimension)"
            />
          }
          <button
            type="button"
            class="bn-case-list__reset"
            (click)="resetFilters()"
          >
            Reset
          </button>
        </div>
      }

      @if (store.isEmpty()) {
        <div
          class="flex flex-col items-center justify-center gap-2 text-surface-500 text-sm py-8"
          role="status"
        >
          <p>No open cases</p>
        </div>
      } @else if (store.isFilterMiss()) {
        <div
          class="bn-case-list__filter-miss flex flex-col items-center gap-2 text-surface-500 text-sm py-8"
          role="status"
        >
          <p>No cases match these filters.</p>
          <button
            type="button"
            class="bn-case-list__reset"
            (click)="resetFilters()"
          >
            Reset to defaults
          </button>
        </div>
      } @else {
        @for (group of store.groupedCases(); track group.key) {
          <bn-case-group [group]="group" />
        }
      }
    </div>
  } @else if (activeView() === 'actions') {
    <div
      id="bn-care-plan-open-actions-panel"
      role="tabpanel"
      aria-labelledby="bn-care-plan-open-actions-tab"
    >
      <bn-open-actions-list
        [store]="actionsStore"
        (goToCase)="goToCase($event)"
      />
    </div>
  } @else {
    <div
      id="bn-care-plan-unlinked-outcomes-panel"
      role="tabpanel"
      aria-labelledby="bn-care-plan-unlinked-outcomes-tab"
    >
      <bn-unlinked-outcomes-list [store]="outcomesStore" />
    </div>
  }
</div>
